/**
* Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      if ( $( '.left-right-marquee__splide' ).length ) {
        $( '.left-right-marquee__splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            focus: 'center',
            arrows: false,
            pagination: false,
            drag: false,
            autoWidth: true,
            autoHeight: false,
            speed: 4000,
            interval: 0,
            rewind: false,
            autoScroll: {
              speed: 0.75,
              pauseOnFocus: false,
              pauseOnHover: false,
              rewind: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'left-right', COMPONENT );
} )( app );
